export default __webpack_public_path__ + "static/media/star.dc5f5a9d.png";